// Mostly copied from
// https://github.com/amazon-archives/amazon-cognito-identity-js/blob/master/src/StorageHelper.js
export class MemoryStorage {
    constructor() {
        this.dataMemory = new Map();
    }
    setItem(key, value) {
        this.dataMemory.set(key, value);
        return this.dataMemory[key];
    }
    getItem(key) {
        return this.dataMemory.get(key);
    }
    getItems() {
        return Object.fromEntries(this.dataMemory.entries());
    }
    removeItem(key) {
        this.dataMemory.delete(key);
        return this.getItems();
    }
    clear() {
        this.dataMemory.clear();
        return this.getItems();
    }
}
